import React, { useState } from 'react';
import TextField from '../../../../components/common/TextField';
import { SelectBox } from '../../../../components/common/SelectBox';

import { formatDate, formatNumber } from '../../../../common/Util';
import ItemTitleSection from './ItemTitleSection';
import DatePicker from '../../../../components/common/DatePicker';
import { theme } from '../../../../theme/theme';
import Tooltip from '../../../../components/common/Tooltip';

const DonationDetailItem = ({
  inputList,
  data,
  handleChange,
  dataIndex,
  codeList,
  t,
  handleDeleteButton,
  disabled,
}) => {
  const [focusedField, setFocusedField] = useState(null);
  const [isTyping, setIsTyping] = useState(false);

  const isCarryoverField = key => key === 'htm027' || key === 'htm028';

  const handleFocus = key => {
    if (isCarryoverField(key)) {
      setFocusedField(key);
    }
  };

  const handleBlur = () => {
    setFocusedField(null);
    setIsTyping(false);
  };

  const handleInputChange = (e, item, dataIndex) => {
    if (isCarryoverField(item.key)) {
      setIsTyping(true);
    }
    handleChange(e, item, dataIndex);
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      {inputList.map((item, index) => {
        if (item.input === 'selectBox') {
          return (
            <React.Fragment key={index}>
              {index === 0 && (
                <ItemTitleSection
                  title={`${t('detail.title')}${dataIndex + 1}`}
                  handleDeleteButton={() => handleDeleteButton(dataIndex)}
                  buttonIcon={!disabled}
                />
              )}
              <SelectBox
                name={item.key}
                label={item.label}
                onChange={e => handleChange(e, item, dataIndex)}
                disabled={item.key == 'htm016' || disabled}
                value={data[item.key]}>
                {codeList(item.key, data)}
              </SelectBox>
            </React.Fragment>
          );
        } else if (item.isDate) {
          return (
            <DatePicker
              key={item.key}
              value={formatDate(data[item.key] || '')}
              name={item.key}
              label={item.label}
              onChange={e => handleChange(e, item, dataIndex)}
              disabled={disabled}
            />
          );
        } else {
          const textFieldElement = (
            <TextField
              label={item.label}
              size="small"
              color={item.color}
              variant={item.variant}
              value={item.isNumber ? formatNumber(data[item.key]) : data[item.key]}
              name={item.key}
              onChange={e => handleInputChange(e, item, dataIndex)}
              disabled={disabled || item.disabled}
              inputStyle={{
                backgroundColor: item.color === 'secondary' ? 'var(--Primary-100)' : '',
              }}
              onInputFocus={() => handleFocus(item.key)}
              onInputBlur={handleBlur}
            />
          );

          return (
            <React.Fragment key={item.key}>
              {item.key === 'htm027' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    marginTop: '8px',
                  }}>
                  <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                    {t('detail.carryoverSection')}
                  </span>
                  <div
                    style={{
                      flex: 1,
                      height: '1px',
                      backgroundColor: theme.colors.grayScale400,
                    }}
                  />
                </div>
              )}
              {isCarryoverField(item.key) ? (
                <Tooltip
                  message="2024년 국세청에 제출했던 이월 기부금 명세서를 증빙 자료로 꼭 제출해주세요."
                  visible={focusedField === item.key && isTyping}>
                  {textFieldElement}
                </Tooltip>
              ) : (
                textFieldElement
              )}
            </React.Fragment>
          );
        }
      })}
    </div>
  );
};

export default DonationDetailItem;
